import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PortalLayoutComponent } from './portal-layout.component';
import { RTL } from '@progress/kendo-angular-l10n';
import { PortalNotFoundComponent } from './not-found/not-found.component';
import { PortalToastComponent } from './toast/toast.component';
import { PortalToastStackTraceComponent } from './toast/stackTrace/toast-stack-trace.component';
import { PortalLoaderComponent } from './loader/loader.component';
import { PortalConfirmationDialogComponent } from './confimation-dialog/confirmation-dialog.component';
import { InfrastructureModule } from '../../../../../infra/infrastructure.module';

@NgModule({
  declarations: [
    PortalLayoutComponent,
    PortalNotFoundComponent,
    PortalLoaderComponent,
    PortalToastComponent,
    PortalToastStackTraceComponent,
    PortalConfirmationDialogComponent
  ],
  imports: [
    RouterModule,
    InfrastructureModule
  ],
  providers: [
    { provide: RTL, useValue: true },
  ],
  exports: [
  ]
})
export class PortalLayoutModule {
}
